<template>
  <ToggleSection
    label="Run Parameters"
    icon-classes="fa-solid fa-dna"
    :collapsed="!dv.isEditing"
  >
    <FieldGrid
      class="form-fields"
      :fields="[
        ['widget:instrumentData'],
        ['flowcell', 'flowcell_version'],
        ['runtype'],
        ['runmode'],
        ['chemistry'],
        ['live_base_calling'],
        ['live_read_mapping', 'slot:fc:genome_reference'],
        ['adaptive_mode'],
        ['adaptive_mode_details'],
      ]"
      :dv="dv"
    >
      <template v-if="liveReadMapping" #genome_reference>
        <FieldComponent
          :field-meta="dv.modelAttributes['genome_reference']"
          :data="dv.editedRecord['genome_reference']"
          :is-edit-mode="dv.isEditing"
          @edit="(value) => dv.edit({ name: 'genome_reference' }, value)"
        />
      </template>
    </FieldGrid>
  </ToggleSection>
</template>

<script>
import { useNanoporeConditionalFields } from '@/composables/validation/assay/useSequencingValidation'
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'NanoporeRunParameters',
  components: {
    ToggleSection,
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const { liveReadMapping } = useNanoporeConditionalFields(props.dv)

    return { liveReadMapping }
  },
}
</script>
